import { List } from '@apollo/orbit';
import classnames from 'classnames';
import { MomentInput } from 'moment';
import React from 'react';
import { Redirect, Route } from 'react-router';

import { FieldsListQuery } from 'src/lib/graphqlTypes/types';
import {
  NormalizedFieldsMetricsField,
  fromGQLFieldListItemtoFieldListItem,
} from 'src/lib/metrics';
import { mergeQueryParams } from 'src/lib/routing';

import { FieldsListItem } from '../insightsListItem/FieldsListItem';

type FieldsListProps = {
  data: FieldsListQuery;
  timeFrom: MomentInput;
  timeTo: MomentInput;
  selectedField?: string;
  statsSortKey: NormalizedFieldsMetricsField;
  loading: boolean;
};

export const FieldsListBody = ({
  data,
  selectedField,
  statsSortKey,
  loading,
}: FieldsListProps) => {
  const fields = data?.graph?.variant?.fieldInsightsList?.fields ?? [];
  // Redirect to url with query name if available data is found.
  if (!selectedField) {
    return (
      <Route>
        {({ location }) => (
          <Redirect
            to={{
              ...location,
              search: mergeQueryParams(location.search, {
                queryName: selectedField,
              }),
            }}
          />
        )}
      </Route>
    );
  }

  const fieldsListQueryItems = fields.map((fieldStats) => {
    const normalizedField = fromGQLFieldListItemtoFieldListItem(fieldStats);

    return {
      ...fromGQLFieldListItemtoFieldListItem(fieldStats),
      statsSortKey,
      isSelected: normalizedField.name === selectedField,
    };
  });

  const fieldsListContent = fieldsListQueryItems.map((item) => (
    <FieldsListItem key={item.name} {...item} loading={loading} />
  ));

  return fieldsListQueryItems.length > 0 ? (
    <List
      isInteractive
      className={classnames('pt-2', {
        'motion-safe:animate-pulse-faded': loading,
      })}
    >
      {fieldsListContent}
    </List>
  ) : null;
};
